import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  min-width: 1280px;
  min-height: 590px;
  background-size: 100% 100%;
  background: #2c2c2c;
  @media screen and (min-width: 1440px) {
    min-height: 678px;
  }
  @media screen and (min-width: 1920px) {
    min-height: 836px;
  }
`;
